__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "cl-mainpage-host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.99.0", () => (Promise.all([__webpack_require__.e(8980), __webpack_require__.e(3556)]).then(() => (() => (__webpack_require__(8980))))));
			register("class-variance-authority", "0.7.1", () => (__webpack_require__.e(2732).then(() => (() => (__webpack_require__(2732))))));
			register("lucide-react", "0.462.0", () => (Promise.all([__webpack_require__.e(6619), __webpack_require__.e(3556)]).then(() => (() => (__webpack_require__(6619))))));
			register("radix-ui", "1.6.0", () => (Promise.all([__webpack_require__.e(3895), __webpack_require__.e(3556), __webpack_require__.e(8393), __webpack_require__.e(4848)]).then(() => (() => (__webpack_require__(3895))))));
			register("react-dom", "19.2.5", () => (Promise.all([__webpack_require__.e(3556), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(2648), __webpack_require__.e(3556), __webpack_require__.e(8393)]).then(() => (() => (__webpack_require__(2648))))));
			register("react-toastify", "11.1.0", () => (Promise.all([__webpack_require__.e(1409), __webpack_require__.e(3556)]).then(() => (() => (__webpack_require__(1409))))));
			register("react", "19.2.5", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(6540))))));
			register("tailwind-merge", "2.6.1", () => (__webpack_require__.e(856).then(() => (() => (__webpack_require__(856))))));
			register("zustand", "5.0.13", () => (Promise.all([__webpack_require__.e(3556), __webpack_require__.e(5618)]).then(() => (() => (__webpack_require__(5618))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};